import LanguageBar from "../LanguageSwitcher";
import logo from "../../assets/images/big-c.jpg";
import BackButton from "../common/BackButton";
import { useNavigate } from "react-router-dom";

const LoginHeader = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    /*if (window.history.length > 2) {
      window.history.go(-1); // หรือ -2 ตามต้องการ
    } else {
      window.location.href = "/"; // fallback หากไม่มีหน้าให้ย้อน
    }*/
   window.location.href = "/"; 
    //navigate(sessionStorage.getItem("previousPath"));
  };

  return (
    <div className="w-full h-22 bg-primary flex justify-between items-end px-5 pt-2 pb-2">
      <BackButton onClick={handleGoBack} />
      <img src={logo} alt="Big C" className="w-20 h-auto my-auto" />
      <LanguageBar className="w-26 h-9 p-1 rounded-full bg-primary-dark text-primary-text-dark mb-4" />
    </div>
  );
};

export default LoginHeader;
